export default "__VITE_ASSET__NG0YwhNu__"